import { CloudLogApi } from "./api.cloud";
import { BoxLogApi } from "./api.box";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseLogApi } from "./api.base";
import environment from "@/config";

export default getService<BaseLogApi>(environment.nexus, {
    box: new BoxLogApi(),
    cloud: new CloudLogApi(),
    demo: new CloudLogApi(),
});